module.exports = __webpack_public_path__ + "static/media/dash-icon-black.4f3aa1bd.svg";